module.exports = __webpack_public_path__ + "static/v1.d-thumb-38a780c93a6fed42040959179a855533.jpg";